export const PERFILES_REQUEST = "PERFILES_REQUEST";
export const PERFILES_OK = "PERFILES_OK";
export const PERFILES_REFRESH = "PERFILES_REFRESH";
export const PERFILES_ERROR = "PERFILES_ERROR";
